import { Environment } from '../../interface/environment.interface';
import { SystemKeys } from '../../const/system-keys';
import { project, scopes, channel } from '../../project/project';
import { firebaseConfig } from '../../project/firebase.config';

export const environment: Environment = {
    remoteDev: false,
    dev: false,
    uat: false,
    sit: true,
    staging: false,
    prod: false,
    e2e: false,
    native: false,
    secureFlag: false,
    buildNumber: project.buildNumber,
    mobileApiPath: project.mobileApiPath,
    version: project.version,
    channel: channel,
    manifest: 'module-federation.sit.manifest.json',
    allowPrincipalKeys: [SystemKeys.SYSTEM_PRINCIPAL_KEYS.SBOG_GROUP, SystemKeys.SYSTEM_PRINCIPAL_KEYS.SBOG],
    bankingPrincipalKeys: [SystemKeys.SYSTEM_PRINCIPAL_KEYS.SBOG_GROUP, SystemKeys.SYSTEM_PRINCIPAL_KEYS.SBOG],
    allowCountries: [{ countryCode: SystemKeys.COUNTRY_CODES.PBBI, isSupported: true }],
    errorManagement: {
        showErrorReportDialog: false,
        enabled: false,
        useLogQueen: false,
        enableHttpErrorLogging: false,
        sampleRate: 0.9
    },
    tracing: {
        enabled: false,
        sampleRate: 0.9
    },
    pingInfo: {
        client_id: '627e933f-0f89-4ee9-9f79-00757030d11a',
        hostURI: 'https://enterprisestssit.standardbank.co.za',
        scopes: scopes
    },
    trusteerId: '',
    firebaseConfig: firebaseConfig,
    useProductionPinEncryptKey: false
};
